import React, { useState, useEffect } from "react";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem("esther_cookies")) setShow(true); }, []);
  const accept = () => { localStorage.setItem("esther_cookies", "1"); setShow(false); };
  if (!show) return null;
  return (
    <div className="fixed bottom-0 inset-x-0 z-[65] bg-noir/95 backdrop-blur text-white/80 px-4 py-4" data-testid="cookie-banner">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center gap-4 justify-between">
        <p className="text-xs sm:text-sm text-center sm:text-left">Nous utilisons des cookies pour améliorer votre expérience sur notre boutique. En poursuivant, vous acceptez notre politique de confidentialité.</p>
        <div className="flex gap-3 shrink-0">
          <button onClick={accept} className="border border-white/30 text-white px-4 py-2 text-xs uppercase tracking-widest hover:bg-white/10 transition-colors" data-testid="cookie-refuse">Refuser</button>
          <button onClick={accept} className="bg-dore text-noir px-5 py-2 text-xs uppercase tracking-widest font-semibold hover:bg-dore/90 transition-colors" data-testid="cookie-accept">Accepter</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
